// src/common/navigationHistory.js
import { createContext, useContext, useRef } from 'react';

const NavigationHistoryContext = createContext();

export const NavigationHistoryProvider = ({ children }) => {
  const historyRef = useRef([]);

  const push = (path) => {
    historyRef.current.push(path);
  };

  const getPrevious = () => {
    const len = historyRef.current.length;
    return len >= 2 ? historyRef.current[len - 2] : null;
  };

  return (
    <NavigationHistoryContext.Provider value={{ push, getPrevious }}>
      {children}
    </NavigationHistoryContext.Provider>
  );
};

export const useNavigationHistory = () =>
  useContext(NavigationHistoryContext);
